import { LayoutBreakpoints, LayoutElement } from "@entaconsulting/form";
import { set } from "lodash";
import getElementSize from "./getElementSize";
import reduceSizeByBreakpoint from "./reduceSizeByBreakpoint";

const findBiggestElement = (
  elements: any[],
  insertAt: number,
  rowStart: number,
  rowEnd: number,
  activeBreakpoint: NonNullable<LayoutBreakpoints>
) => {
  let maxSize = 1;
  let biggestElement = null;

  //recorrer hacia la derecha
  for (let i = insertAt; i <= rowEnd; i++) {
    let element = elements[i];
    let elementSize = getElementSize(element, activeBreakpoint);
    if (elementSize > maxSize) {
      maxSize = elementSize;
      biggestElement = element;
    }
  }
  //recorrer hacia la izquierda
  for (let i = insertAt - 1; i >= rowStart; i--) {
    let element = elements[i];
    let elementSize = getElementSize(element, activeBreakpoint);
    if (elementSize > maxSize) {
      maxSize = elementSize;
      biggestElement = element;
    }
  }

  return biggestElement;
};

const resizeRowElements = (
  newElementSize: number,
  elements: LayoutElement[],
  insertAt: number,
  rowStart: number,
  rowEnd: number,
  activeBreakpoint: NonNullable<LayoutBreakpoints>
): void => {
  const elementsInRow: number = rowEnd - rowStart + 1;
  let unavailableSpace: number = 0;

  if (elementsInRow > 12) return;

  for (let i = rowStart; i <= rowEnd; i++) {
    unavailableSpace += getElementSize(elements[i], activeBreakpoint);
  }

  let availableSpace = 12 + newElementSize - unavailableSpace;
  let spaceToGenerate = newElementSize - availableSpace;

  while (spaceToGenerate > 0) {
    let element = findBiggestElement(
      elements,
      insertAt,
      rowStart,
      rowEnd,
      activeBreakpoint
    );

    if (element) {
      const newSize = reduceSizeByBreakpoint(element);
      set(element, "size", newSize);
      spaceToGenerate--;
    }
  }
};

export default resizeRowElements;
